import { IAction, KEEP_THE_SAME, StateStatus } from 'redux/utils/common';
import * as Types from './types';
import { ISpecificationAttributeListOutput } from 'services/api/specificationattribute';
import * as ProductService from 'services/api/product';
import { IDescriptionData } from '../configuration';

export interface IState {
  editSpecificationAttribute: {
    status: StateStatus | null;
  };
  viewSpecificationAttribute: {
    status: StateStatus | null;
    data: any;
  };
  segments: {
    data: ProductService.ISegments | null;
    status: StateStatus | null;
  };
  temporaryName: IDescriptionData[];
  listIcon: {
    data: any | null;
    status: StateStatus | null;
  };
}

const initialState: IState = {
  editSpecificationAttribute: {
    status: null,
  },
  viewSpecificationAttribute: {
    status: null,
    data: null,
  },
  segments: {
    data: null,
    status: null,
  },
  listIcon: {
    data: null,
    status: null,
  },
  temporaryName: [],
};

const SpecificationAttributeReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_EDIT_SPECIFICATIONATTRIBUTE:
      return {
        ...state,
        editSpecificationAttribute: {
          ...state.editSpecificationAttribute,
          status: action.status || null,
        },
      };
    case Types.SET_SPECIFICATIONATTRIBUTE_DETAIL:
      return {
        ...state,
        viewSpecificationAttribute: {
          ...state.viewSpecificationAttribute,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? state.viewSpecificationAttribute.data
              : action.data,
        },
      };
    case Types.SET_SEGMENTS:
      return {
        ...state,
        segments: {
          ...state.segments,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.SET_LIST_ICON:
      return {
        ...state,
        listIcon: {
          ...state.listIcon,
          status: action.status || null,
          data: action.data,
        },
      };
    case Types.UPDATE_NAME_TEMPORARY:
      return {
        ...state,
        temporaryName: action.data,
      };
    default:
      return {
        ...state,
      };
  }
};

export default SpecificationAttributeReducer;
